import { Fragment, ReactNode, useMemo } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Helmet } from 'react-helmet-async';
import { BACK_URL_PARAM_KEY } from 'hooks/useBackUrl';

const Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  width: 100%;
  padding: 16px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
`;

const LeftSide = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RightSide = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 30px;
  height: 30px;
  border-radius: 8px;

  color: #fff;
  background-color: rgb(24, 144, 255);
`;

const Title = styled('span')`
  font-size: 18px;
  font-weight: 500;
  color: rgb(24, 144, 255);
`;

type Props = { title: string | ReactNode; helmetTitle: string; buttons?: ReactNode[] };

function PageHeader({ title, helmetTitle, buttons }: Props) {
  const location = useLocation();
  const navigate = useNavigate();
  const backUrl = useMemo(() => {
    return new URLSearchParams(location.search).get(BACK_URL_PARAM_KEY);
  }, [location.search]);

  return (
    <>
      <Helmet>
        <title>{helmetTitle}</title>
        <link rel="" href={window.location.href}></link>
      </Helmet>

      <Container>
        <LeftSide>
          {backUrl ? (
            <Button
              type="primary"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate(decodeURIComponent(backUrl))}
              style={{ marginRight: '16px' }}>
              Quay lại
            </Button>
          ) : (
            <IconContainer>
              <i className="fas fa-home" />
            </IconContainer>
          )}
          <Title>{title}</Title>
        </LeftSide>
        {buttons && (
          <RightSide>
            {buttons.map((button, index) => (
              <Fragment key={index}>{button}</Fragment>
            ))}
          </RightSide>
        )}
      </Container>
    </>
  );
}

export default PageHeader;
